import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Provider } from 'react-redux';
import { store } from './api/store';
import { ToastProvider } from './library/toastify/toast-provider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
      <ToastProvider>
        <Routes>
          <Route path='/*' element={<App/>}/>
        </Routes>
      </ToastProvider>
    </BrowserRouter>
    </Provider>
  </React.StrictMode>
);